import { store } from 'app/app-store';
import { loginActions } from 'app/state/login/login-slice';
import { payloadActions } from 'app/state/payload/payload-slice';
import { Auth } from 'aws-amplify';
import get from 'lodash/get';
import { batch } from 'react-redux';
import { ROOT_PATH } from 'routes/constants';
import { history } from 'routes/history';
import { Alert } from 'rsuite';
import { StrRegistrationAPISender } from './str-registration-api-sender';
import { checkCognitoUserForCustomerPortal } from './utility-functions';

export class AuthSender extends StrRegistrationAPISender {
  setCustomJWT(jwt) {
    this.customJWT = jwt;
    this.setAdminFlowMode(Boolean(jwt));
  }

  async setToken() {
    // getting the current session will refresh the token
    let idToken;
    if (this.customJWT) {
      idToken = this.customJWT;
    } else {
      const cognitoUserSession = await Auth.currentSession();
      idToken = cognitoUserSession.idToken.jwtToken;
    }
    this.axiosInstance.defaults.headers.common.Authorization = `Bearer ${idToken}`;
  }

  async validateAuthedPortalUser() {
    const usingCustomerPortal = get(store.getState(), 'app.stats.app.type') === 'portal';
    if (!usingCustomerPortal) return true;

    const placeString = get(store.getState(), 'app.stats.cityInfo.place');
    let isValidAuthedPortalUser;

    try {
      const congitoCurrentAuthenticatedUser = await Auth.currentAuthenticatedUser();
      isValidAuthedPortalUser = checkCognitoUserForCustomerPortal(placeString, congitoCurrentAuthenticatedUser.username);
    } catch (err) {
      isValidAuthedPortalUser = false;
    }

    if (!isValidAuthedPortalUser) {
      batch(() => {
        store.dispatch(loginActions.setOpenLoginModal(false));
        store.dispatch(loginActions.setCognitoUserDetails(null));
        store.dispatch(payloadActions.setLookupModeEmail(null));
        store.dispatch(loginActions.setUserAccountDetails(null));
      });

      await Auth.signOut();

      Alert.closeAll();
      Alert.warning('Your session has either expired or is invalid. Please log in again before re-attempting.', 10000);

      history.push(ROOT_PATH);
    }

    return isValidAuthedPortalUser;
  }

  async rawGet(...args) {
    if (!this.validateAuthedPortalUser(...args)) return;

    await this.setToken();
    return super.rawGet(...args);
  }

  async get(...args) {
    if (!this.validateAuthedPortalUser(...args)) return;

    await this.setToken();
    return super.get(...args);
  }

  async post(...args) {
    if (!this.validateAuthedPortalUser(...args)) return;

    await this.setToken();
    return super.post(...args);
  }

  async getNoPlace(...args) {
    if (!this.validateAuthedPortalUser(...args)) return;

    await this.setToken();
    return super.getNoPlace(...args);
  }
}

export const authSender = new AuthSender();
